import React from 'react';
import { BoolToString } from 'components';
import { getTableColumns } from 'helpers';

const RegStepsColumns = [
  ...getTableColumns(
    [
      ['step', 'string', 'Step #', 'center', true],
      ['description', 'string', 'Description', 'left', true]
    ]
  ),
  {
    name: 'isMandatory',
    type: 'string',
    label: 'Required',
    filterable: true,
    align: 'center',
    renderCell: data => (<BoolToString boolValue={data && data.isMandatory} />)
  },
  // {
  //   name: 'isCountAccrual',
  //   type: 'string',
  //   label: 'Count Accrual',
  //   filterable: true,
  //   renderCell: data => (<BoolToString boolValue={data && data.isCountAccrual} />)
  // },
  {
    name: 'isCountTowards',
    type: 'string',
    label: 'Count Towards',
    filterable: true,
    align: 'center',
    renderCell: data => (<BoolToString boolValue={data && data.isCountTowards} />)
  },
  ...getTableColumns(
    [
      ['stepType', 'string', 'Step Type', 'left', true],
      ['loadTo', 'string', 'Load To', 'left', true]
    ]
  ),
  {
    name: 'isProcessedInFm',
    type: 'string',
    label: 'FM?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isProcessedInFm} />)
  },
  {
    name: 'isLoadToCaaers',
    type: 'string',
    label: 'caAERS Load?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isLoadToCaaers} />)
  },
  {
    name: 'isSlot',
    type: 'string',
    label: 'Slot?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isSlot} />)
  },
  {
    name: 'isCmStep',
    type: 'string',
    label: 'Central Monitoring?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isCmStep} />)
  },
  {
    name: 'isEligibilityReviewStep',
    type: 'string',
    align: 'center',
    label: 'Eligibility Review?',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isEligibilityReviewStep} />)
  },
  ...getTableColumns(
    [
      ['startDate', 'string', 'Start Date', 'center', true],
      ['endDate', 'string', 'End Date', 'center', true]
    ]
  ),
  {
    name: 'minNonReqCred',
    type: 'string',
    align: 'center',
    label: 'Minimum Non-required Credentials',
    filterable: true
  },
  {
    name: 'maxNonReqCred',
    type: 'string',
    align: 'center',
    label: 'Maximum Non-required Credentials',
    filterable: true,
    renderCell: data => data?.maxNonReqCred || '0'
  }
];


export default RegStepsColumns;
